const works = [
  {
    name: "Portfolio",
    imageUrl:
    "/pic/react1.jpg",
    description:
      "2021. Portfolio svetainė, sukurta su React ir Bootstrap",
      butUrl: "http://cvreact.vercel.app",
  },
  {
    name: "Flores",
    imageUrl:
    "/pic/flor.jpg",
    description:
      "2008. Svetainė skirta švietimo įstaigoms, ruošiančioms želdynų specialistus ir įmonėms, teikiančioms želdinimo paslaugas. Sukurta su WordPress",
      butUrl: "http://flores.lt",
  },  
  {
    name: "Prancūzų buldogų veislynas",
    imageUrl:
    "/pic/frenc.jpg",
    description:
      "2006. Prancūzų buldogų veislyno tinklapis. Sukurta su WordPress",
      butUrl: "http://triumfoarka.com",
  },
  {
    name: "Kelionių agentūra",
    imageUrl:
    "/pic/ut.jpg",
    description:
      "2008. Kelionių agentūros tinklapis. Pritaikyta TVS WordPress, diegtos rezervacijos sistemos, SEO, dizainas. Sukurta su WordPress",
      butUrl: "",
  },
  {
    name: "Suvenyrų parduotuvė",
    imageUrl:
    "/pic/lietuviskosdovanos.jpg",
    description:
      "2011. lietuviskosdovanos.lt sukurta ir administruota elektroninė parduotuvė su TVS PrestaShop",
      butUrl: "",
  },
  {
      name: "Šalių vėliavos",
      imageUrl:
        "/pic/salys1.jpg",
      description:
        "2021. KITM užduotis. Panaudota JavaScript, Listbox. Filtruoja šalis iš JSON failo pagal žemynus.",
        butUrl: "http://replit.com/@DonatasM/pagalsali",
    },
    {
      name: "Flex blokų išdėstymas.",
      imageUrl:
        "/pic/flex.jpg",
      description:
        "2021. KITM užduotis. Panaudota CSS. Flex",
        butUrl: "http://replit.com/@DonatasM/flex-sav-intik",
    },
    {
      name: "Bootstrap tinklapis",
      imageUrl:
        "/pic/bootstrap.jpg",
      description:
        "2021. KITM savarankiška užduotis. Panaudota HTML, Bootstrap",
        butUrl: "http://replit.com/@DonatasM/sav-darbas",
    },
    {
      name: "Straipsniai",
      imageUrl:
      "/pic/fetch.jpg",
      description:
        "2021. KITM užduotis. Straipsnių skaitymas iš JSON failo. Meniu filtruoja straipsnius pagal kategorijas. Fono spalva generuojama iš 6 spalvų",
        butUrl: "https://replit.com/@DonatasM/fetchSuMeniu",
    },
    {
      name: "Filmų paieška",
      imageUrl:
      "/pic/movie.jpg",
      description:
        "2021. KITM užduotis. Filmų paieška iš JSON failų. React + Bootstrap. ",
        butUrl: "https://github.com/donataskitm/json-movies",
    },
    {
      name: "Prekių krepšelis",
      imageUrl:
      "/pic/shop.jpg",
      description:
        "2021. KITM užduotis. Atlikta su React + Bootstrap. Prekių atvaizdavimas, pridėjimas įkrepšelį. Bendros sumos skaičiavimas",
        butUrl: "https://github.com/donataskitm/React-bootstrap-e-shopp.git",
    },
    {
      name: "Pavedimai tarp sąskaitų. ",
      imageUrl:
      "/pic/bank.jpg",
      description:
        "2021. KITM užduotis. Panaudota Laravel.",
        butUrl: "https://github.com/donataskitm/bank.git",
    },
    
    
   
  ];
  export default works